// extracted by mini-css-extract-plugin
module.exports = {"body":"styles__body___2Nona","panel":"styles__panel___3UXhz","empty":"styles__empty___7t6E_"};